<template>
  <div class="text-xs-center appcontainer">
    <h1 class="display-2" style="margin-top: 10%;color: deeppink;">{{ msg }}</h1>
    <v-btn large v-if="loginRequired" color="info" @click="login"> Login </v-btn>
  </div>
</template>

<script>
import axios from 'axios'
import { SERVER_URL } from '@/constant.js'

export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome To Admin Dashboard',
      loginRequired: false,
      loginUrl: ''
    }
  },
  created() {
    document.title = 'Home';
    axios.get(`${SERVER_URL}/report/authorized`)
    .then(res => {
      if (res && res.data == 'success') {
        // LoggedIn.
        console.log("You are loggedIn.");
      } else {
        console.log("Login Required.");
        this.loginUrl = res.request.responseURL;
        this.loginRequired = true;
      }
    })
  },
  methods: {
    login () {
      window.location = this.loginUrl;
    }
  }
}
</script>

<style scoped>
h1, h2 {
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue